/* unplugin-vue-components disabled */import { render } from "./restricted.vue?vue&type=template&id=5925efcc&scoped=true"
const script = {}

import "./restricted.vue?vue&type=style&index=0&id=5925efcc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5925efcc"],['__file',"src/components/ai-chat-v2/ai-file/restricted.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5925efcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5925efcc', __exports__)) {
    api.reload('5925efcc', __exports__)
  }
  
  module.hot.accept("./restricted.vue?vue&type=template&id=5925efcc&scoped=true", () => {
    api.rerender('5925efcc', render)
  })

}


export default __exports__